import { Amplify } from 'aws-amplify';
import cognitoProdConfig from './configs/aws-exports-prod.js';
import cognitoQaConfig from './configs/aws-exports-qa.js';
import cognitoStagingConfig from './configs/aws-exports-staging.js';

const AUTH_ENV_VS_CONFIG = {
    PROD: cognitoProdConfig,
    DEV: cognitoStagingConfig,
    QA: cognitoQaConfig
};
const initializeAuth = (currentEnv)=>{
    Amplify.configure(AUTH_ENV_VS_CONFIG[currentEnv]);
};

export { initializeAuth as default };
//# sourceMappingURL=auth.initializer.js.map
